import React from "react";

/**
 * QuickAnswer — NerdWallet-style summary card directly below the hero.
 * Renders only when the processor was able to extract a coherent 1–2
 * sentence summary from the first paragraph.
 */
export function QuickAnswer({ text }) {
  if (!text) return null;
  return (
    <aside
      className="not-prose rounded-2xl border border-[#0066FF]/15 bg-gradient-to-br from-[#F0F7FF] to-[#FAFCFF] p-6 lg:p-7 mb-10"
      data-testid="blog-quick-answer"
    >
      <div className="flex items-start gap-4">
        <div
          aria-hidden="true"
          className="shrink-0 mt-0.5 w-9 h-9 rounded-full bg-[#0066FF] text-white flex items-center justify-center font-display text-lg font-semibold"
        >
          ★
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.14em] font-semibold text-[#0066FF] mb-1.5">
            Quick answer
          </div>
          <p className="text-[16px] leading-[1.65] text-[#0A2540] m-0">{text}</p>
        </div>
      </div>
    </aside>
  );
}
